import { EPaymentType } from '@common/enums';

export const getPaymentMethodCurrency = <T extends object>(settings: T): string | null => {
    if (!settings) return null;

    if ('currency' in settings) return settings.currency as string;
    if ('fiatCurrency' in settings)
        return (
            settings.fiatCurrency ? settings.fiatCurrency : 'cryptoCurrency' in settings && settings.cryptoCurrency
        ) as string;

    return null;
};

const paymentTypeMapping: Record<string, EPaymentType> = {
    YOOMONEY: EPaymentType.yooMoney,
    PAYPAL: EPaymentType.payPal,
    FONDY: EPaymentType.fondy,
    YOUKASSA: EPaymentType.youKassa,
    ROBOCASSA: EPaymentType.roboKassa,
    STRIPE: EPaymentType.stripe,
    MERCADOPAGO: EPaymentType.mercadopago,
    LIQPAY: EPaymentType.liqpay,
    WAYFORPAY: EPaymentType.wayforpay,
    FLUTTERWAVE: EPaymentType.flutterwave,
    MONOBANK: EPaymentType.monobank,
    CRYPTOMUS: EPaymentType.cryptomus,
    CUSTOM: EPaymentType.custom,
    WHITEPAY: EPaymentType.whitepay,
    KLARNA: EPaymentType.klarna,
    STRIPECONNECT: EPaymentType.stripeConnect,
    ROZETKAPAY: EPaymentType.rozetkaPay,
};
export const convertStringToPaymentType = (type: string): EPaymentType | null => {
    const normalizedType = type.toUpperCase();
    if (normalizedType in paymentTypeMapping) {
        return paymentTypeMapping[normalizedType];
    }

    return null;
};
